import store from "@/store";

export default async (to, from, next) => {
  try {
    await store.dispatch("loadCertificates");
    next();
  } catch (error) {
    console.error('DEBUG: [modelList] error', error);
  }
};
